import { useState } from "react";
import { useSignedImage } from "../useSignedImage";

interface HtmlImageRendererWebProps {
  src: string;
  alt?: string;
}

export const HtmlImageRendererWeb = ({ src, alt }: HtmlImageRendererWebProps) => {
    const signedUrl = useSignedImage(src);
    const [loaded, setLoaded] = useState(false);
  
    if (!signedUrl) {
      return (
        <img
          src=""
          alt={alt || ""}
          style={{
            display: "none",
          }}
        />
      );
    }
  
    return (
      <img
        src={signedUrl}
        alt={alt || ""}
        onLoad={() => setLoaded(true)}
        style={{
          width: "100%",
          maxHeight: "460px",
          objectFit: "contain",
          borderRadius: "8px",
          display: loaded ? "block" : "none",
        }}
      />
    );
};
